<template src="./Details.html">
</template>

<script>
export default {
        props: {
            itemId: {
                type: Number,
                required: true,
            },
        },

        created() {
            this.$store
                .dispatch("complaints/getDetails", this.itemId)
                .then(() => {

                })
                .catch(() => { });
        },
  computed: {
      complaint() {
          return this.$store.state.complaints.complaint;
      }
  },
};
</script>